
export const isBrowser = typeof document !== 'undefined';

// export function setClientCookie(name: string, value: string, days?: number) {
//   let expires = "";
//   if (days) {
//     const date = new Date();
//     date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//     expires = "; expires=" + date.toUTCString();
//   }
//   document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
// }

// export function getClientCookie(name: string): string | null {
//   if (!isBrowser) return null;
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return decodeURIComponent(parts[1].split(';')[0]);
//   return null;
// }

export function setURL(path: string) {
  globalThis.history.replaceState({}, path, path);
}